import './CustomSelect.scss'
import * as React from 'react'
import { IconButton, Select } from '@material-ui/core'
import { ArrowDropDown, Close } from '@material-ui/icons'

interface ISelectProps {
	children: React.ReactNode
	inputProps: { id: string; name: string }
	isClearable?: boolean
	onChange: (event: any) => void
	value: any
}

const CustomSelect = (props: ISelectProps) => {
	const { children, inputProps, isClearable, onChange, value } = props

	const getClearableProps = () => {
        const [indOpen, setIndOpen] = React.useState<boolean>(false)

	    const handleOpen = () => setIndOpen((prev) => !prev)
        const handleClear = () => onChange({ target: { name: inputProps.name, value: null } })

        return {
            IconComponent: () => <React.Fragment />,
            SelectDisplayProps: {
                style: { marginRight: !!value ? '-48px' : '-24px' },
            },
            endAdornment: (
                <>
                    {!!value && (
                        <IconButton onClick={handleClear}>
                            <Close />
                        </IconButton>
                    )}
                    <IconButton onClick={handleOpen}>
                        <ArrowDropDown />
                    </IconButton>
                </>
            ),
            onClose: handleOpen,
            onOpen: handleOpen,
            open: indOpen,
        }
    }

	const isClearableProps = !!isClearable ? getClearableProps() : {}

	return (
		<Select
			className='custom-select'
			value={value}
			onChange={onChange}
			inputProps={inputProps}
			{...isClearableProps}
		>
			{children}
		</Select>
	)
}

export default React.memo(CustomSelect)



// WEBPACK FOOTER //
// ./src/component/shared/custom-select/CustomSelect.tsx